import { useState } from 'react';

// Hooks 
import {  useAppDispatch } from '../../misc/hooks'

// Actions
import {updateSource} from '../../slice/user'

// Icons
import IconClose from "../../assets/icons/icon_close";

import { Checkbox } from "../_common/ui/checkbox/checkbox";

function PopinSource() {
	const [open, setOpen] = useState<boolean>(true)
	const [source, setSource] = useState<string>('')
	const [customSource, setCustomSource] = useState<string>('')
	const [error, setError] = useState<string>('')

	const dispatch = useAppDispatch()

	const handleCheck = (value: string) => {
		setSource(value)
	}

	const handleSubmit = (value?: string) => {
		if (!source && value !== 'none') {
			setError('Please select one option.')
		} else {
			dispatch(updateSource({source: source === 'other' ? 'other: ' + customSource : source || 'no_answered'}))
			setOpen(false)
		}
	}

	return open ?(
		<div className="popin-source">
			<div className="popin-source__container">
				<button className="popin-source__container-close" onClick={() => handleSubmit('none')}>
					<IconClose/>
				</button> 

				<div className="popin-source__container-title">
					Help us improve
				</div> 

				<div className="popin-source__container-question">
					How did you hear about us ? (Select one)
				</div> 

				<ul className="popin-source__container-list">
					<li className="popin-source__container-option" onClick={()=> handleCheck('shopify_app_store')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'shopify_app_store'} />
						</button>
						<p className="popin-source__container-option-label">
							Shopify App Store
						</p>
					</li>
					<li className="popin-source__container-option" onClick={()=> handleCheck('youtube')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'youtube'} />
						</button>
						<p className="popin-source__container-option-label">
							Youtube
						</p>
					</li>
					<li className="popin-source__container-option" onClick={()=> handleCheck('x')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'x'} />
						</button>
						<p className="popin-source__container-option-label">
							X
						</p>
					</li>
					<li className="popin-source__container-option" onClick={()=> handleCheck('tiktok')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'tiktok'} />
						</button>
						<p className="popin-source__container-option-label">
							Tiktok
						</p>
					</li>
					<li className="popin-source__container-option" onClick={()=> handleCheck('instagram')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'instagram'} />
						</button>
						<p className="popin-source__container-option-label">
							Instagram
						</p>
					</li>
					<li className="popin-source__container-option other" onClick={()=> handleCheck('other')}>
						<button className="popin-source__container-option-check">
							<Checkbox value={source === 'other'} />
						</button>
						<p className="popin-source__container-option-label">
							Other (please specify)
						</p>
					</li>
					<input 
						onClick={()=> handleCheck('other')}
						className="popin-source__container-option-input" 
						type="text" placeholder="e.g, word of mouth, Google search, etc." 
						value={customSource} 
						onChange={ e => setCustomSource(e.target.value)} 
						/>

				</ul>

				{/* Button submit */}
				<button className="popin-source__container-btn-submit" onClick={() => handleSubmit()}>
					Submit & Continue

					{error ?
						<div className="popin-source__container-error" >{error}</div>
					:''}

				</button>



			</div> 
		</div> 
	) : <></>
}

export default PopinSource;
